import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals.js';
import { ClerkProvider } from '@clerk/clerk-react';
import { clerkPubKey } from './lib/clerk.js';
import FirebaseAuthBridge from './components/Auth/FirebaseAuthBridge.js';
import { firebaseConfigError } from './lib/firebase.js';
import LocalPreview from './preview/LocalPreview.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Keep the visual/story preview usable anywhere credentials are absent. This
// prevents Clerk from mounting with an undefined publishableKey in local,
// preview, or staging deployments.
const isLocalPreview = !clerkPubKey || firebaseConfigError;

// Keep local visual review available when auth/database credentials have not
// been pulled into the workspace. Configured environments use the real app.
root.render(
  <React.StrictMode>
    {isLocalPreview ? (
      <HelmetProvider>
        <LocalPreview />
      </HelmetProvider>
    ) : (
      <ClerkProvider publishableKey={clerkPubKey}>
        <HelmetProvider>
          <FirebaseAuthBridge>
            <App />
          </FirebaseAuthBridge>
        </HelmetProvider>
      </ClerkProvider>
    )}
  </React.StrictMode>
);
